import dataPeriRiva from "../../../../src/data/periprocedureel-beleid-rivaroxaban.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataPeriRiva,
  BasicSchematic,
  React
};